<nav id="sidebar">
    <ul class="p-0">
        <li class="nav-item class1">
            <span class="spam-text-title">{{'System Profiles'|translate}}</span>
            <ul class="class2">
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="my-profile">
                        <span class=" spam-text">{{'My Profile'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="administrators">
                        <span class=" spam-text">{{'Administrators'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="tech-support">
                        <span class="spam-text">{{'Tech Support'|translate}}</span>
                    </a>
                </li>
            </ul>
        </li>
        <li class="nav-item class1">
            <span class=" spam-text-title">{{'Business'|translate}}</span>
            <ul class="class2">
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="membership-plans">
                        <span class="spam-text">{{'Membership Plans'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="payment-processors">
                        <span class="spam-text">{{'Payment Processors'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="payments">
                        <span class="spam-text">{{'Payments'|translate}}</span>
                    </a>
                </li>
            </ul>
        </li>
        <li class="nav-item class1">
            <span class="spam-text-title">{{'Members'|translate}}</span>
            <ul class="class2">            
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="member-companies">
                        <span class="spam-text">{{'Member Companies'|translate}}</span>
                    </a>
                </li>
                <li class="nav-item nav-item-button" routerLinkActive="active">
                    <a routerLink="app-users">
                        <span class="spam-text">{{'App Users'|translate}}</span>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</nav>